import { useRef } from 'react';
import { useEditor } from '../../hooks/useEditor.js';
import { renderNode } from '../../utils/renderNode.js';
import { Scroller, Viewport, Content, Container } from './Canvas.style.js';
import { PreviewModeContainer } from './PreviewModeContainer.js';
import { jsx } from '@emotion/react';

function Canvas(_ref) {
  var width = _ref.width,
    id = _ref.id,
    className = _ref.className;
  var _useEditor = useEditor(),
    _useEditor$state = _useEditor.state,
    document = _useEditor$state.document,
    displayMode = _useEditor$state.displayMode,
    components = _useEditor.components;
  var cacheRef = useRef({});
  var Container$1 = displayMode === 'edit' ? Container : PreviewModeContainer;
  return jsx(Container$1, {
    id: id,
    className: className
  }, jsx(Scroller, {
    id: "canvas-scroller"
  }, jsx(Viewport, {
    id: "canvas-viewport",
    width: width
  }, jsx(Content, {
    id: "canvas-content",
    shadow: displayMode === 'edit'
  }, renderNode(document, components, [], cacheRef.current)))), jsx("div", {
    id: "highlighter-root",
    style: {
      position: 'relative'
    }
  }));
}

export { Canvas };
//# sourceMappingURL=Canvas.js.map
